
import { message } from 'antd';
import { find } from 'lodash';
import { addAndUpdateVendorInjection, getVendorInjection, deleteVendorInjection } from '../services/supplierApi';

function init() {
  return {
    data: [],
    record: {},
    visiable: false
  };
}

export default {
  namespace: 'plasticAbility',
  state: init(),
  effects: {
    *getData(_, { call, put }) {
      const res = yield call(getVendorInjection);
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: res.data
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *showEditModal({ payload: { data: { serialNumberI } } }, { put, select }) {
      const data = yield select(state => state.plasticAbility.data);
      const record = find(data, { serialNumberI });
      yield put({
        type: 'updateState',
        payload: {
          data: {
            record,
            visible: true
          }
        }
      });
    },
    *addAndUpdate({ payload: { data } }, { call, put }) {
      const result = yield call(addAndUpdateVendorInjection, data);
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'updateState',
          payload: {
            data: {
              visible: false
            }
          }
        });
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *delete({ payload: { serialNumberI } }, { call, put }) {
      const result = yield call(deleteVendorInjection, { serialNumber: serialNumberI });
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};

